import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import ImageWithFallback from "./ImageWithFallback";
import { hapticTap, openLink } from "@/tg/init";
import { DONATE_URL } from "@/lib/links";
import type { SectionItem } from "@/api";

export default function ReportCard({ item }: { item: SectionItem }) {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <div
      style={{
        background: "var(--tint)",
        borderRadius: "var(--r-card)",
        padding: 8,
        marginBottom: 12,
      }}
    >
      <div style={{ width: "100%", aspectRatio: "16 / 10", overflow: "hidden", borderRadius: 8 }}>
        <ImageWithFallback
          src={item.image}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>

      <div style={{ padding: "8px 4px 4px" }}>
        <h3
          className="line-clamp-2"
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            fontFamily: '"e-UkraineHead", system-ui, sans-serif',
            color: "var(--ink)",
            lineHeight: 1.3,
          }}
        >
          {item.title}
        </h3>

        {item.subtitle && (
          <p
            style={{
              margin: "6px 0 0",
              fontSize: 14,
              lineHeight: 1.5,
              color: "var(--text)",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {item.subtitle}
          </p>
        )}

        <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
          <button
            onClick={() => { hapticTap(); openLink(DONATE_URL); }}
            style={{
              flex: 1,
              height: 44,
              borderRadius: "var(--r-pill)",
              background: "var(--brand-blue)",
              color: "#fff",
              border: "none",
              fontFamily: '"e-Ukraine", system-ui, sans-serif',
              fontSize: 15,
              fontWeight: 500,
              cursor: "pointer",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            {t("donate")}
          </button>

          <button
            onClick={() => { hapticTap(); navigate(`/detail/${item.kind}/${item.id}`); }}
            style={{
              flex: 1,
              height: 44,
              borderRadius: "var(--r-pill)",
              background: "#fff",
              color: "var(--ink)",
              border: "1px solid var(--border)",
              fontFamily: '"e-Ukraine", system-ui, sans-serif',
              fontSize: 15,
              fontWeight: 500,
              cursor: "pointer",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            {t("more_details")}
          </button>
        </div>
      </div>
    </div>
  );
}
